var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-toggle',
                        view: publicPath + 'sprite.svg#view-icon-toggle',
                        viewBox: '0 0 11 11',
                        title: 'Fill 1',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };